import { Expose } from 'class-transformer'

export class PromotionHistoryType {
  @Expose() id: number

  @Expose() createdAt: string
}
